interface StateType {
    mainBackground: string;
    qixiBtn: string;
    wheelBackground: string;
    circleBackground: string;
    bottomBackground: string;
    shelfBackground: string;
}
type stateKey = keyof StateType;

interface PayloadType {
    key: stateKey;
    value: string;
}

export default {
    state: {
        mainBackground: '',
        qixiBtn: '',
        wheelBackground: '',
        circleBackground: '',
        bottomBackground: '',
        shelfBackground: ''
    },
    mutations: {
        setBackgrondValue(state: StateType, playLoad: PayloadType) {
            const { key, value } = playLoad;
            if (state[key]) return;
            state[key] = value;
        }
    },

    namespaced: true
};
